import React from 'react';
import { motion } from 'framer-motion';
import { posts } from '../../data/posts';
import { LinkButton } from '../LinkButton';
import { SplitText } from '../SplitText';
export function Blog() {
  return <section id="blog" className="px-5 py-[6.25rem] sm:py-[9.375rem] md:px-10" data-id="element-40" data-mp="ry0h074m8svq">
      <div className="mx-auto flex max-w-[71.875rem] flex-col items-stretch md:items-center" data-id="element-41" data-mp="vzm38j31ijil">
        <SplitText as="h2" text="Read what's happening" className="mb-8 text-[2rem] font-medium leading-[1.34] tracking-[0.47px] md:text-[3.063rem] md:tracking-[0.7px] lg:mb-[9.375rem]" data-id="element-42" data-mp="3vez8v3eatlkr" />
        <ul className="grid w-full grid-cols-1 gap-y-[3.125rem] sm:gap-y-16 md:grid-cols-2 md:gap-x-16 md:gap-y-24 lg:gap-x-[4.375rem] lg:gap-y-[5.63rem]" data-id="element-43" data-mp="8a01poz73s7f">
          {posts.map((post, i) => <motion.li key={post.title}
        // Soft rise + fade, row by row with a light left-to-right offset — same easing as the rest of the page.
        initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.8,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-44" data-mp="1jq7ytavuybbp" data-mpi={i}>
              <a href={post.href} className="blog-item group flex items-center justify-between gap-[1.5625rem] sm:gap-[1.875rem]" data-id="element-45" data-mp="ik3weewzc180">
                <span className="flex-1 text-[1.25rem] font-normal leading-[1.5] tracking-[0.01em] text-black sm:text-[2rem]" data-id="element-46" data-mp="doyb9ibeiqkz">
                  <span className="blog-underline" data-id="element-47" data-mp="4tqoudo02oj7">{post.title}</span>
                </span>
                <img src={post.image} alt="" loading="lazy" className="aspect-[3/2] w-[2.875rem] flex-none object-cover transition-transform duration-300 ease-out group-hover:scale-110 sm:w-[6.25rem]" data-id="element-48" data-mp="3w0blccwtqonm" />
              </a>
            </motion.li>)}
        </ul>
        <div className="mt-[5.625rem] flex justify-center sm:mt-[7.5rem]" data-id="element-49" data-mp="3i1lpt1pnkx1d">
          <LinkButton label="Read more" href="https://immersivestudios-83fafce90a550c3da614bf.webflow.io/blog" variant="muted" data-id="element-50" data-mp="37ex6oq22954o" />
        </div>
      </div>
    </section>;
}